import { render } from "./DocumentTypesInfoModal.vue?vue&type=template&id=17f9720a&ts=true"
import script from "./DocumentTypesInfoModal.vue?vue&type=script&lang=ts"
export * from "./DocumentTypesInfoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__